//#region Imports
import type { IReadonlyUserDetailsRecord, IReadonlyUserSubscriptionStatusRecord } from "@anydo/interfaces";
//#endregion

export function isUserDetailsPremiumUser(
  userDetails: IReadonlyUserDetailsRecord | null | undefined,
  userSubscription: IReadonlyUserSubscriptionStatusRecord | null | undefined,
): userSubscription is IReadonlyUserSubscriptionStatusRecord {
  // if isPremium is true
  if (userDetails?.isPremium) {
    // if userSubscription exists
    if (userSubscription != null) {
      // check subscription expiration
      return userSubscription.serverExpirationDate > Date.now();
    }

    return true;
  }
  return false;
}
